export const CANCEL_SUBSCRIPTION = 'SUBSCRIPTION/CANCEL_SUBSCRIPTION';
export const DISCARD_SUBSCRIPTION_CANCELLATION = 'SUBSCRIPTION/DISCARD_SUBSCRIPTION_CANCELLATION';
export const FETCH_USER_SUBSCRIPTIONS = 'SUBSCRIPTION/FETCH_USER_SUBSCRIPTIONS';
export const SET_USER_SUBSCRIPTIONS = 'SUBSCRIPTION/SET_USER_SUBSCRIPTIONS';
export const UNSUBSCRIBE = 'SUBSCRIPTION/UNSUBSCRIBE';
export const SET_FETCHING_STATUS = 'SUBSCRIPTION/SET_FETCHING_STATUS';
export const SET_CANCELLATION_CANDIDATE = 'SUBSCRIPTION/SET_CANCELLATION_CANDIDATE';
export const SET_CANCEL_REMINDER = 'SUBSCRIPTION/SET_CANCEL_REMINDER';
